// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"chatBot_wrapper__1_gUZ","button":"chatBot_button__2xKhJ"};